import { Loading, Typography } from "@cpj-ai/panel-npm-package";
import { useGetJobSeekersInterestedJobsQuery } from "@graphql/generated";
import { Card, Chip } from "@heroui/react";
import { useParams } from "react-router-dom";

const JobInterestsTabContent = () => {
  const { id } = useParams();
  const { data, loading, error } = useGetJobSeekersInterestedJobsQuery({
    variables: { id: id ?? "" },
    skip: !id,
  });

  const interestedJobs =
    data?.admin?.jobSeekers?.edges?.[0]?.node?.profile?.interestedJobs?.edges?.map((e) => e?.node).filter(Boolean) ??
    [];

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <Typography className="text-danger">Unable to load job interests. Please try again later.</Typography>
    );
  }

  if (interestedJobs.length === 0) {
    return (
      <Card className="p-6">
        <Typography className="text-default-500">No job interests added yet.</Typography>
      </Card>
    );
  }

  return (
    <div className="space-y-3">
      <Typography className="text-sm text-default-500">
        {interestedJobs.length} job{interestedJobs.length !== 1 ? "s" : ""} of interest
      </Typography>
      <ul className="space-y-2 list-none p-0 m-0">
        {interestedJobs.map((job, index) => {
          const industries =
            job?.industries?.edges
              ?.map((e) => e?.node?.title)
              .filter(Boolean)
              .join(", ") ?? "—";
          return (
            <li key={index}>
              <Card className="p-4 shadow-none border border-default-200">
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <div className="min-w-0 flex-1">
                    <Typography className="font-medium">{job?.title ?? "—"}</Typography>
                    {industries !== "—" && (
                      <Typography className="text-sm text-default-500 mt-1">{industries}</Typography>
                    )}
                  </div>
                  {job?.requireAppearanceData && (
                    <Chip size="sm" variant="flat" color="primary">
                      Requires appearance
                    </Chip>
                  )}
                </div>
              </Card>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default JobInterestsTabContent;
